/**
 * Utility function to determine the active vertical based on current URL
 * @returns The active vertical ('flights' | 'hotels' | 'buses' | null)
 */
export const getActiveVertical = (): string | null => {
    if (typeof window === 'undefined') return null

    const pathname = window.location.pathname.toLowerCase()

    if (pathname.includes('/hotels')) {
        return 'hotels'
    }

    if (pathname.includes('/flights') || pathname === '/' || /^\/[a-z]{2}\/?$/.test(pathname)) {
        return 'flights'
    }

    return null
}

/**
 * Check if a specific vertical is active
 * @param vertical - The vertical to check ('flights' | 'hotels' | 'buses')
 * @returns boolean indicating if the vertical is active
 */
export const isVerticalActive = (vertical: string): boolean => {
    const activeVertical = getActiveVertical()
    return activeVertical === vertical.toLowerCase()
}
